module.exports = __webpack_public_path__ + "img/Verification.3401dbbb.svg";